import { Navigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { useSubscription } from '../hooks/useSubscription';
import { useEffect, useState } from 'react';

interface ProtectedRouteProps {
  children: React.ReactNode;
  requiresSubscription?: boolean;
  allowFreeAccess?: boolean;
}

export default function ProtectedRoute({ children, requiresSubscription = true, allowFreeAccess = false }: ProtectedRouteProps) {
  const { user, isLoading } = useAuth();
  const { hasActiveSubscription } = useSubscription();
  const [isReady, setIsReady] = useState(false);

  useEffect(() => {
    // Wait for auth state to be determined
    if (!isLoading) {
      setIsReady(true);
    }
  }, [isLoading]);

  // Show nothing while checking auth state
  if (!isReady) {
    return null;
  }

  // Redirect to home if not authenticated
  if (!user && isReady) {
    return <Navigate to="/" replace />;
  }

  // Check subscription status if required
  if (
    requiresSubscription &&
    !allowFreeAccess &&
    isReady &&
    !hasActiveSubscription()
  ) {
    return <Navigate to="/dashboard" replace />;
  }

  return <>{children}</>;
}